import { render, staticRenderFns } from "./ManageServiceItem.vue?vue&type=template&id=43209990&scoped=true&lang=pug&"
import script from "./ManageServiceItem.vue?vue&type=script&lang=js&"
export * from "./ManageServiceItem.vue?vue&type=script&lang=js&"
import style0 from "./ManageServiceItem.vue?vue&type=style&index=0&id=43209990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43209990",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VDivider,VIcon,VList,VListItem,VListItemTitle,VMenu,VSpacer})
